import React from 'react';
import LinksFooter, {
  ALLOWED_URLS,
  LinksFooterProps,
} from '../../../../../../components/App/footer/LinksFooter/LinksFooter';
import { useMediaQuery, useTheme } from '@mui/material';
import logo_footer from '../../../../assets/Fringand_White.svg';
import { getPolyglot } from '../../../../../../i18n';

function LinksFooterFF(props: LinksFooterProps) {
  const theme = useTheme();
  const polyglot = getPolyglot();

  const isTablet = useMediaQuery(theme.breakpoints.down('md'));
  const {
    logoFooter = logo_footer,
    predefinedLinks = {
      [ALLOWED_URLS.IMPRESSUM]: {
        label: polyglot.t('footer.impressum'),
        to: 'https://www.foursfringand.com/fr/mentions-legales/',
        external: true,
      },
      [ALLOWED_URLS.TERMS_AND_CONDITIONS]: {
        label: polyglot.t('footer.terms_and_conditions'),
        to: 'foursfringand.com/en/terms-and-conditions/',
        external: false,
      },
      [ALLOWED_URLS.COOKIE_POLICY]: {
        label: polyglot.t('footer.cookie_policy'),
        to: 'https://www.foursfringand.com/fr/politique-confidentialite/',
        external: true,
      },
      [ALLOWED_URLS.ABOUT_US]: {
        label: polyglot.t('footer.about_us'),
        to: 'https://www.foursfringand.com/en/lentreprise-fringand/',
        external: true,
      },
    },
  } = props;
  return (
    <LinksFooter
      logoFooter={logoFooter}
      logoHeight={isTablet ? 20 : 30}
      predefinedLinks={predefinedLinks}
    />
  );
}

export default LinksFooterFF;
